export default __webpack_public_path__ + "static/media/backer-nodeseeds.b071f2e8.png";